/**
 * TGH Senior Center — Testimonials slider
 * Dependency-free. Slides per view are driven by CSS (--tgh-per-view),
 * so breakpoints live in testimonials.css only.
 * Supports buttons, keyboard arrows, pointer swipe, resize.
 */
(function () {
  'use strict';

  function Slider(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-tgh-slider-viewport]');
    this.track = root.querySelector('[data-tgh-slider-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-tgh-slide]'));
    this.prev = root.querySelector('[data-tgh-slider-prev]');
    this.next = root.querySelector('[data-tgh-slider-next]');
    this.index = 0;
    if (!this.viewport || !this.track || !this.slides.length) return;
    this.bind();
    this.update();
  }

  Slider.prototype.perView = function () {
    var value = parseInt(getComputedStyle(this.track).getPropertyValue('--tgh-per-view'), 10);
    return value > 0 ? value : 1;
  };

  Slider.prototype.maxIndex = function () {
    return Math.max(0, this.slides.length - this.perView());
  };

  Slider.prototype.offsetFor = function (index) {
    var slide = this.slides[index];
    return slide ? slide.offsetLeft - this.slides[0].offsetLeft : 0;
  };

  Slider.prototype.goTo = function (index) {
    this.index = Math.min(Math.max(index, 0), this.maxIndex());
    this.update();
  };

  Slider.prototype.update = function () {
    var perView = this.perView();
    var self = this;
    if (this.index > this.maxIndex()) this.index = this.maxIndex();
    this.track.style.transform = 'translate3d(' + (-this.offsetFor(this.index)) + 'px,0,0)';

    this.slides.forEach(function (slide, i) {
      var visible = i >= self.index && i < self.index + perView;
      slide.setAttribute('aria-hidden', String(!visible));
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (visible) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
      });
    });

    if (this.prev) this.prev.disabled = this.index <= 0;
    if (this.next) this.next.disabled = this.index >= this.maxIndex();
    this.root.classList.toggle('is-static', this.maxIndex() === 0);
  };

  Slider.prototype.bind = function () {
    var self = this;

    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1); });

    this.root.addEventListener('keydown', function (event) {
      if (event.target.closest('input, textarea')) return;
      if (event.key === 'ArrowLeft') self.goTo(self.index - 1);
      if (event.key === 'ArrowRight') self.goTo(self.index + 1);
    });

    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var dragging = false;
    var locked = false;

    this.viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      locked = false;
      startX = event.clientX;
      startY = event.clientY;
      deltaX = 0;
    });

    this.viewport.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (!locked) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
        locked = true;
        self.track.classList.add('is-dragging');
        self.viewport.setPointerCapture(event.pointerId);
      }
      deltaX = dx;
      var edge = (self.index === 0 && dx > 0) || (self.index === self.maxIndex() && dx < 0);
      var shift = -self.offsetFor(self.index) + (edge ? dx * 0.3 : dx);
      self.track.style.transform = 'translate3d(' + shift + 'px,0,0)';
    });

    function end() {
      if (!dragging) return;
      dragging = false;
      self.track.classList.remove('is-dragging');
      if (!locked) return;
      var threshold = Math.min(80, self.viewport.clientWidth * 0.15);
      if (deltaX < -threshold) self.goTo(self.index + 1);
      else if (deltaX > threshold) self.goTo(self.index - 1);
      else self.update();
    }

    this.viewport.addEventListener('pointerup', end);
    this.viewport.addEventListener('pointercancel', end);

    this.viewport.addEventListener('click', function (event) {
      if (Math.abs(deltaX) > 6) { event.preventDefault(); deltaX = 0; }
    }, true);

    var raf = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { self.update(); });
    });
  };

  function init() {
    document.querySelectorAll('[data-tgh-slider]').forEach(function (root) {
      if (root.dataset.tghReady) return;
      root.dataset.tghReady = '1';
      new Slider(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/testimonials.js